import { FC } from 'react';
import styles from './AppliedGiftCard.module.scss';
import { Icon } from 'components/Icon';

interface AppliedGiftCardProps {
  last4: string;
  balance: string;
  token: string;
  handleGiftCardRemoval: (token: string) => void;
}
export const AppliedGiftCard: FC<AppliedGiftCardProps> = ({ last4, balance, token, handleGiftCardRemoval }) => {
  const handleKeyDown = (event: any) => {
    if (event.keyCode === 13 || event.keyCode === 32) {
      handleGiftCardRemoval(token);
    }
  };

  return (
    <div className={styles.giftCardContainer} data-testid="giftCard">
      <Icon className={styles.giftIcon} name="gift" data-testid="giftIcon" />
        <span className={styles.giftCardNumber} data-testid="giftCardNumber">
          •••• {last4}
        </span>
        <span className={styles.giftCardBalance} data-testid="giftCardBalance">{`($${balance})`}</span>
        <div
          className={styles.cancelIcon}
          onClick={() => handleGiftCardRemoval(token)}
          role="button"
          tabIndex={0}
          onKeyDown={handleKeyDown}
          data-testid={`cancelIcon-${token}`}
          aria-label="cancelGiftCardIcon"
        >
          <Icon name="cancel" />
        </div>
      </div>
  );
};
